import { DocumentType } from '@sib/api';

export const DEFAULT_MIN_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_SIZES = [5, 10, 20, 50, 100];
export const EXCLUDED_DOCUMENT_TYPE = DocumentType.Invoice;

export const DEFAULT_MIN_COLUMN_SIZE = 200;
export const DEFAULT_SELECT_COLUMN_SIZE = 50;

export const DATA_TABLE_GROUP_HEADER_HEIGHT = '2.25rem';
export const DATA_TABLE_GROUP_HEADER_HEIGHT_VAR =
  '--data-table-group-header-height';

export const pageSizeOptions = PAGE_SIZES.map(size => ({
  label: size,
  value: String(size),
}));
